import isUndefined from "lodash-es/isUndefined";

import type { LegalFilterKey } from "../types/productTypes";

const filterTranslations: Partial<Record<LegalFilterKey, Record<string, string>>> = {
   certifications: {
      nyt_norge: "Nyt Norge",
      nokkelhullet: "Nøkkelhullet",
      eu_okologi: "Økologisk (EU)",
      fsc: "Bærekraftig emballasje (FSC)",
      debio: "Økologisk (Debio)",
      grontpunkt: "Grønt Punkt"
   },
   brandGroup: {
      Biola: "Biola",
      Diplomis: "Diplom-is",
      Dovre: "Dovre",
      Fjordland: "Fjordland",
      GoMorgen: "Go'morgen",
      Gryr: "Gryr®",
      Isklar: "Isklar",
      Iste: "Iste",
      Jarlsberg: "Jarlsberg",
      Kulinaris: "Kulinaris",
      Litago: "Litago",
      Lollipop: "Lollipop",
      TINE: "TINE",
      Nicks: "Nick's",
      Noisy: "Noisy",
      Norvegia: "Norvegia",
      Royal: "Royal",
      SelbuBlaa: "Selbu Blå",
      Snofrisk: "Snøfrisk",
      Sunniva: "Sunniva",
      Tonitto: "Tonitto",
      YT: "YT",
      Ostavind: "Østavind",
      Other: "Øvrige"
   }
};

/**
 * Looks up the value for a given field and translates it if available in filterTranslations
 */
export const translateFilterValue = (fieldKey: LegalFilterKey, fieldValue: string) => {
   if (!(fieldKey in filterTranslations) || typeof fieldValue === "undefined") {
      if (fieldKey === "sizeRange" || fieldKey === "volumeRange" || fieldKey === "weightRange") {
         return fieldValue?.replace(/1\/2/g, "½")?.replace(/1\/3/g, "⅓")?.replace(/1\/4/g, "¼") ?? fieldValue;
      }
      return fieldValue;
   }

   const translatedValues = filterTranslations[fieldKey];
   if (isUndefined(translatedValues)) {
      return fieldValue;
   }

   return translatedValues[fieldValue] ?? translatedValues[fieldValue.toLowerCase()] ?? fieldValue;
};
